import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Watches from './pages/Watches';
import WatchForm from './pages/WatchForm';
import Brands from './pages/Brands';
import Categories from './pages/Categories';
import Orders from './pages/Orders';
import Users from './pages/Users';
import Messages from './pages/Messages';
import BuyerChat from './pages/BuyerChat';
import Settings from './pages/Settings';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { CurrencyProvider } from './contexts/CurrencyContext';

function App() {
  return (
    <div className="dark">
      <AuthProvider>
        <CurrencyProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/chat" element={<BuyerChat />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Navigate to="/dashboard" replace />} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/watches" element={<Watches />} />
                      <Route path="/watches/new" element={<WatchForm />} />
                      <Route path="/watches/:id/edit" element={<WatchForm />} />
                      <Route path="/brands" element={<Brands />} />
                      <Route path="/categories" element={<Categories />} />
                      <Route path="/orders" element={<Orders />} />
                      <Route path="/users" element={<Users />} />
                      <Route path="/messages" element={<Messages />} />
                      <Route path="/settings" element={<Settings />} />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        </CurrencyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;